import { Middleware, isRejectedWithValue } from '@reduxjs/toolkit';
import { tenantClosedDetected } from './slices/globalSlice';
import { isTenantArchivedError } from '../utils/tenantArchived';

/** Read locally: importing `RootState` from the store would be circular. */
interface TenantState {
    legacy?: { authentication?: { tenant?: string | null } };
    global?: { closedTenant?: string | null };
}

/**
 * #1379: every backend answers an archived tenant's own users with 403
 * `tenant_archived` — on the account routes, the data routes and the Lambda
 * routes alike. Whichever request meets it first, this turns it into one
 * state flag, so the whole app shows "This account has been closed" instead
 * of each screen rendering its own generic error (or, worse, an empty list).
 *
 * The choke point is the rejected RTK Query action, not one base query: the
 * slices use three different base queries, and all of them end here.
 */
export const tenantArchivedMiddleware: Middleware = (api) => (next) => (action) => {
    if (isRejectedWithValue(action) && isTenantArchivedError(action.payload)) {
        const state = api.getState() as TenantState;
        const tenant = state.legacy?.authentication?.tenant ?? '';
        if (state.global?.closedTenant !== tenant) {
            api.dispatch(tenantClosedDetected(tenant));
        }
    }
    return next(action);
};
